import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[privacySensitive]'
})
export class PrivacySensitiveDirective {
  constructor(private _hostElement: ElementRef, private _renderer: Renderer2) {
    _renderer.addClass(_hostElement.nativeElement, 'usabilla-dont-show');
    _renderer.setAttribute(_hostElement.nativeElement, 'data-hj-suppress', '');
  }
}
